export default "__VITE_ASSET__BymtWK4U__"